import { useCurrentLanguage } from '@app/i18n';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { DateFormats, FormattableDateValue } from '../../types';
import isDateValid from '../../utils/isDateValid';
import FORMATS from './data/formats';

/**
 *
 * @param considerTimeZone Determines whether to use users local timezone vs UTC - defaults to true
 */
const useFormatDate = (considerTimeZone = true) => {
  const language = useCurrentLanguage();
  const { t } = useTranslation();

  return useCallback(
    (value: FormattableDateValue, format: DateFormats): string => {
      if (!value || !isDateValid(value)) {
        return t('N/A');
      }

      const date = new Date(value);

      return new Intl.DateTimeFormat(language.locale, {
        ...FORMATS[format],
        ...(considerTimeZone && { timeZone: undefined }),
      }).format(date);
    },
    [language.locale, t],
  );
};

export default useFormatDate;
